import { computed } from 'vue';

export function useBlockHelpers(block) {
  const parseStyleString = (styleString) => {
    if (!styleString) return {}
    return styleString.split(';').reduce((acc, style) => {
      const [key, value] = style.split(':').map(s => s.trim())
      if (key) {
        acc[key] = value
      }
      return acc
    }, {})
  }

  const isImageWithAttachment = computed(() => {
    return block.block_type === 'image' && block.image_url
  });

  const isImageWithoutAttachment = computed(() => {
    return block.block_type === 'image' && !block.image_url
  });

  const isDrawingOrShape = computed(() => {
    return block.block_type === 'drawing' || block.block_type === 'shape'
  });

  // The server's array is the order. Merging in the page's order instead sent a
  // just-edited shared block to the end of the slide: its first edit forks it
  // under a new id, which looked like an addition.
  const reconcileBlocks = (currentBlocks, updatedBlocks) => {
    return updatedBlocks.map(updatedBlock => {
      const currentBlock = currentBlocks.find(candidate => candidate.id === updatedBlock.id)
      return currentBlock ? { ...currentBlock, ...updatedBlock } : updatedBlock
    })
  }

  return {
    parseStyleString,
    isImageWithAttachment,
    isImageWithoutAttachment,
    isDrawingOrShape,
    reconcileBlocks
  }
}
